module.exports = __webpack_public_path__ + "img/red-uparrow.f084def3.svg";